import { PlacementInterface } from '../../../interfaces/placement.interface';

export class UpdatePlacements {
    public static readonly type = '[JobsPlacements] Update placements';

    constructor(public placements: PlacementInterface[]) {}
}
